import React, { useEffect, useState } from "react";
import { Modal, Form, DatePicker, Radio, Input, Button, message, Select } from "antd";
import axios from "axios";
import moment from "moment";
import { Option } from "antd/es/mentions";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

const CompensationLeaveForm = ({ visible, onClose, approverId, fetchData }) => {

    const [form] = Form.useForm();
    const [formAudit] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [leaveMode, setLeaveMode] = useState("FULL_DAY");
    const [auditorOptions, setAuditorOptions] = useState([]);
    const [auditorId, setAuditorId] = useState(null);
    useEffect(() => {
        const fetchAuditorOptions = async () => {
            try {
                const res = await axios.get(
                    `${apiUrl}/api/auth/getAllRepresentatives`
                );
                console.log(res.data.data, "auditor options");
                setAuditorOptions(
                    res.data.data.map((auditor) => ({
                        value: auditor._id,
                        label: auditor.userName,
                    }))
                );
            } catch (err) {
                message.error("Failed to fetch auditor options");
            }
        };

        fetchAuditorOptions();
    }, []);



    const [leaveBalance, setLeaveBalance] = useState({
        sick: 0,
        casual: 0,
        comp: 0,
    });

    const apiUrl = process.env.REACT_APP_API_URL;
    console.log(auditorOptions, "auditorId in preview leave form");
    /* ---------------- Fetch Leave Balance ---------------- */
    useEffect(() => {
        if (!auditorId) return;

        const fetchLeaveBalance = async () => {
            try {
                const res = await axios.get(
                    `${apiUrl}/api/worklogs/calculateLeaveData/${auditorId}`
                );

                setLeaveBalance({
                    sick: res.data.nonLOPLeavesAvailable.sick.overall,
                    casual: res.data.nonLOPLeavesAvailable.casual.overall,
                    // comp: res?.data.nonLOPLeavesAvailable.comp.overall,
                });
            } catch {
                message.error("Failed to fetch leave balance");
            }
        };

        fetchLeaveBalance();
    }, [auditorId]);


    const handleAuditSubmit = (values) => {
        setAuditorId(values.auditorId);


    }
    /* ---------------- Submit ---------------- */
    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            // const payload = {
            //     userId: auditorId,
            //     compensationLeaveCount: Number(values.compensation),
            //     reason: values.reason,
            // };

            await axios.post(`${apiUrl}/api/worklogs/add-compensation-leave`, {
                userId: auditorId,
                count: values.compensation,
                reason: values.reason,
            });

            message.success("Compensation leave added successfully");
            form.resetFields();
            setAuditorId(null);
            fetchData?.();
            onClose();
        } catch (err) {
            message.error(err?.response?.data?.message || "Submit failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Compensation Leave form"
            open={visible}
            onCancel={onClose && (() => {
                setAuditorId(null);
                onClose();
            })}
            footer={null}
            centered
        >
            {auditorId === null ? (<Form layout="vertical" form={formAudit} onFinish={handleAuditSubmit}>
                {/* Select Auditor */}
                <Form.Item
                    name="auditorId"
                    label="Select Auditor"
                    rules={[{ required: true }]}
                >
                    <Select
                        placeholder="Select Auditor"
                        options={auditorOptions}
                    />
                </Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} block>
                    Search
                </Button>
            </Form>) : (<Form layout="vertical" form={form} onFinish={handleSubmit}>

                {/* <div className="flex justify-between gap-1"><p> Sick Leave ({leaveBalance.sick})</p>
                <p> Casual Leave ({leaveBalance.casual})</p>
                <p> Compensation Leave ({leaveBalance.comp})</p></div> */}

                <Form.Item
                    name="compensation"
                    label="Compention Leave"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="Enter the leave count" type="number" />

                </Form.Item>

                {/* Reason */}
                <Form.Item
                    name="reason"
                    label="Reason"
                    rules={[{ required: true }]}
                >
                    <TextArea rows={3} />
                </Form.Item>


                <Button type="primary" htmlType="submit" loading={loading} block>
                    Add Leave
                </Button>
            </Form>)}

        </Modal>
    );
};

export default CompensationLeaveForm;